import { component } from 'picoapp';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';

export default component(async (node) => {
  const renderLightbox = node.querySelectorAll('.glightbox');

  const loadLightbox = async () => (
    await import(
      /* webpackChunkName: "glightbox" */
      'modules/glightbox'
    )
  ).default;

  if (renderLightbox.length) {
    loadLightbox();
  }
});
